import Card from '@/components/Card/Card';
import CardHeader from '@/components/Card/CardHeader';
import CustomInput from '@/components/CustomInput/CustomInput';
import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import loader from '../../assets/img/loader.svg';
import Button from '@/components/CustomButtons/Button';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import CardBody from '@/components/Card/CardBody';
import { API_BASE_URL } from '@/config';
import { useNavigate } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { OrganizationsApi } from '@/api/clients/organizations/organizations.api';

export default function CreateTangoGroup() {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);
  const [formInputs, setFormInputs] = useState({
    customerIdentifier: '',
    displayName: '',
  });
  const [organizationId, setOrganizationId] = useState('');
  const [organizations, setOrganizations] = useState([]);

  const [message] = useState('');
  const onInputChange = (e) => {
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const onOrganizationIdChange = (e) => {
    setOrganizationId(e.target.value);
  };

  const CreateTangoGroup = async (e) => {
    e.preventDefault();
    setLoaded(true);
    const requestData = {
      ...formInputs,
      organizationId,
    };
    await axios.post(API_BASE_URL + '/createTangoGroup', requestData);
    setLoaded(false);
    navigate('/admin/TangoPage');
  };

  const cancelfrm = () => {
    navigate('/admin/TangoPage');
  };

  useEffect(() => {
    OrganizationsApi.getOrganizations().then((res) => {
      setOrganizations(res.data.organizations);
    });
  }, []);

  return (
    <div>
      <form onSubmit={CreateTangoGroup}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color='primary'>
                <h4>{t('createTangoGroup.title')}</h4>
              </CardHeader>
              <CardBody>
                {loaded && (
                  <div className='loaders'>
                    <img src={loader} />
                  </div>
                )}

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText={t(
                        'createTangoGroup.fields.customerIdentifier',
                      )}
                      onChange={onInputChange}
                      value={formInputs.customerIdentifier}
                      name='customerIdentifier'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('createTangoGroup.fields.displayName')}
                      name='displayName'
                      onChange={onInputChange}
                      value={formInputs.displayName}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-org'>
                          {t('facilities.create.organizationsLabel')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-org'
                          value={organizationId}
                          onChange={onOrganizationIdChange}
                          name='organization_id'
                          className='full-width-elem'>
                          {organizations.map((obj, index) => (
                            <MenuItem value={obj && obj.id} key={index}>
                              {obj && obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                </GridContainer>

                {message && (
                  <GridContainer>
                    <GridItem xs={8} sm={8} md={6}>
                      <p style={{ color: 'red', padding: '10px 0' }}>
                        {message}
                      </p>
                    </GridItem>
                  </GridContainer>
                )}
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Button color='primary' type='submit'>
                      {t('createTangoGroup.buttons.create')}
                    </Button>
                    <Button
                      color='primary'
                      onClick={cancelfrm}
                      className='btn-cancel'
                      style={{ marginLeft: '5px' }}>
                      {t('createTangoGroup.buttons.cancel')}
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}
